import React, { useEffect, useState } from 'react'
import Navbar from '../components/common/navbar'
import Hero from '../components/home/hero'
import SchoolOverview from '../components/school/schoolOverview'
import Footer from '../components/common/footer'
import api from '../API/api'
import { useParams } from 'react-router-dom'

const SchoolPage = () => {

    const params = useParams();

    const [school, setSchool] = useState();
    const [banner, setBanner] = useState('')
    const [course, setCourse] = useState();
    const [affilited, setAffilited] = useState();

    useEffect(() => {
        // console.log(params,'params');
        getSchoolData()
    }, [params.school]);



    const getSchoolData = () => {
        api.getSchoolData(params.school).then((res) => {
            // console.log("Res==>", res);
            setSchool(res.data.school)
            setBanner(res.data.school.banner)
            setCourse(res.data.present_courses)
            setAffilited(res.data.affilited)

        })
            .catch((err) => {
                // console.log("err==", err.response);
            })
    }


    return (
        <>
            <Navbar />
            <Hero banner={banner} />
            <div className='container-fluid'>
                <SchoolOverview school={school} course={course} affilited={affilited}/>

            </div>

            <Footer />
        </>
    )
}

export default SchoolPage